import type { AnchorType, FieldSchemaModel } from '@/shared/generated'

import { ANCHORS_TYPES } from '@/entities/anchor'

import { FieldType, ValueEditorType, ValueType } from '@/shared/generated'

export function geColumnsSchema(): FieldSchemaModel[] {
	return [
		...schema,
		...ANCHORS_TYPES.map((anchorType: AnchorType) => [
			createColumnSchema({
				value_type: ValueType.String,
				id: `${anchorType}_source_family_id`,
				name: `field_schema_${anchorType}_source_family_id`,
				params: {
					editable: true,
					filterable: true,
					sortable: true,
				},
			}),
			createColumnSchema({
				value_type: ValueType.Number,
				field_type: FieldType.Custom,
				id: `${anchorType}_anchor_count`,
				name: `field_schema_${anchorType}_anchor_count`,
				params: {
					editable: false,
					filterable: true,
					sortable: true,
				},
				/* 				ui_schema: {
					type: 'anchor_count',
				}, */
			}),
			createColumnSchema({
				value_type: ValueType.String,
				field_type: FieldType.Custom,
				id: `${anchorType}_anchor_sku`,
				name: `field_schema_${anchorType}_anchor_sku`,
				params: {
					editable: true,
					filterable: true,
					sortable: true,
				},
			}),
			createColumnSchema({
				value_type: ValueType.Number,
				id: `${anchorType}_anchor_add`,
				name: `field_schema_${anchorType}_anchor_add`,
				params: {
					editable: true,
					filterable: true,
					sortable: true,
				},
			}),
			createColumnSchema({
				value_type: ValueType.Number,
				id: `${anchorType}_anchor_mul`,
				name: `field_schema_${anchorType}_anchor_mul`,
				params: {
					editable: true,
					filterable: true,
					sortable: true,
				},
			}),
		]).flat(),
	] as FieldSchemaModel[]
}

const createColumnSchema = (
	schema: Partial<FieldSchemaModel> = {}
): FieldSchemaModel =>
	({
		...schema,
		params: {
			searchable: true,
			editable: true,
			filterable: true,
			...schema.params,
		},
	}) as FieldSchemaModel
const schema = [
	{
		id: 'sku',
		comparator: 'sku',
		propagate: false,
		params: {
			editable: false,
			searchable: true,
			filterable: true,
			sortable: true,
		},
		value_type: ValueType.String,
		name: 'field_schema_sku',
		filter_schema: {},
		ui_schema: {
			type: 'ident',
		},
	},
	{
		id: 'title',
		comparator: 'title',
		propagate: false,
		params: {
			editable: false,
			searchable: true,
			filterable: true,
			sortable: true,
		},
		value_type: ValueType.String,
		name: 'field_schema_product_name',
	},
	{
		id: 'optimization_group_id',
		comparator: 'optimization_group_id',
		propagate: false,
		params: {
			editable: false,
			searchable: true,
			filterable: true,
			sortable: true,
		},
		field_type: FieldType.Chip,
		value_type: ValueType.String,
		value_editor_type: ValueEditorType.Multiselect,
		name: 'field_schema_optimization_group',
	},
	{
		id: 'anchor_type',
		comparator: 'anchor_type',
		propagate: false,
		params: {
			editable: false,
			searchable: false,
			filterable: false,
			sortable: false,
		},
		value_type: ValueType.Array,
		field_type: FieldType.Custom,
		name: 'field_schema_anchor_type',
	},
	{
		id: 'sales_entity_id',
		propagate: false,
		reference: {
			accessor: 'sales_entity_id',
			entity: 'sales_entity',
			field: 'id',
		},
		params: {
			editable: false,
			searchable: true,
			filterable: false,
			sortable: true,
		},
		value_type: ValueType.String,
		field_type: FieldType.Tree,
		name: 'field_schema_pos_id',
	},
	{
		id: 'line_name',
		comparator: 'line_name',
		propagate: false,
		params: {
			editable: false,
			searchable: true,
			filterable: true,
			sortable: true,
		},
		value_type: ValueType.String,
		name: 'field_schema_line_name',
	},
	{
		id: 'line_id',
		comparator: 'line_id',
		propagate: false,
		params: {
			editable: false,
			searchable: true,
			filterable: true,
			sortable: true,
		},
		value_type: ValueType.String,
		name: 'field_schema_line_id',
	},
	{
		id: 'alerts',
		comparator: 'alerts',
		propagate: false,
		params: {
			editable: false,
			searchable: true,
			filterable: true,
			sortable: true,
		},
		value_type: ValueType.Array,
		field_type: FieldType.Count,
		name: 'field_schema_alerts',
	},
	{
		id: 'updated_at',
		comparator: 'updated_at',
		propagate: false,
		params: {
			sortable: true,
			lockable: true,
			editable: false,
			searchable: false,
			filterable: true,
		},
		value_type: ValueType.String,
		field_type: FieldType.Date,
		value_editor_type: ValueEditorType.Date,
		name: 'field_schema_updated_at',
	},
]
